
import { defineComponent } from 'vue';
import BCXContentArea from '@/components/molecules/BCXContentArea.vue';
import BCXBreadcrumbs from '@/components/molecules/BCXBreadcrumbs.vue';
import Invitees from '@/views/invites/Invitees.vue';
import PartnerProgramCodes from '@/views/invites/PartnerProgramCodes.vue';

export default defineComponent({
  name: 'Partner',
  components: {
    BCXBreadcrumbs,
    BCXContentArea,
    Invitees,
    PartnerProgramCodes,
  },
});
